// Enregistre chaque contrôleur de ce dossier sous l'identifiant tiré de son
// nom de fichier : combobox_controller.js → combobox.
import { application } from './application';

const controllers = import.meta.glob('./*_controller.js', { eager: true });

Object.entries(controllers).forEach(([path, module]) => {
    const identifier = path.replace('./', '').replace('_controller.js', '').replace(/_/g, '-');
    application.register(identifier, module.default);
});
